import { render, staticRenderFns } from "./MeansOfTelecom.vue?vue&type=template&id=2cd8e9ea&scoped=true&"
import script from "./MeansOfTelecom.vue?vue&type=script&lang=js&"
export * from "./MeansOfTelecom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd8e9ea",
  null
  
)

export default component.exports